import * as React from "react";
import { Clipboard, ClipboardCheck } from "react-bootstrap-icons";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

const CopyButton = ({ text }: { text: string }) => {
  const [copied, setCopied] = React.useState(false);
  const handleClick = React.useCallback(() => {
    void (async () => {
      setCopied(true);
      await navigator.clipboard.writeText(text);
      setTimeout(() => setCopied(false), 1000);
    })();
  }, [text]);

  return (
    <OverlayTrigger
      overlay={
        <Tooltip>
          {copied ? "Copied to clipboard!" : "Copy to clipboard"}
        </Tooltip>
      }
    >
      {copied ? (
        <ClipboardCheck />
      ) : (
        <Clipboard onClick={handleClick} style={{ cursor: "pointer" }} />
      )}
    </OverlayTrigger>
  );
};

export default CopyButton;
